enum SitePermissionTypes {
  A = 'Administrator',
  U = 'User',
  F = 'Finance',
  L = 'LIDA Data Entry',
}

export default SitePermissionTypes;
